import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';
import Reference from './types/Reference';

export default class AccountCoverage extends BackboneElement {
    static __className = 'AccountCoverage';

    __objectStructure = {
        coverage: Reference,
        priority: Number,
    };

    constructor(constructJson, className = 'AccountCoverage') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
